module.exports = __webpack_public_path__ + "media/Count03.501a8841.mp3";